import i18n from "./i18n"
import { helpers } from "caradvise_shared_components"

export function formatCurrency(price) {
  const { currencyHelpers } = helpers
  return currencyHelpers.numberFormatToCurrency(price, i18n)
}
